import { render, staticRenderFns } from "./Sso.vue?vue&type=template&id=e5b01ef8&scoped=true&"
import script from "./Sso.vue?vue&type=script&lang=js&"
export * from "./Sso.vue?vue&type=script&lang=js&"
import style0 from "./Sso.vue?vue&type=style&index=0&id=e5b01ef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b01ef8",
  null
  
)

export default component.exports